export const roundToNearest = (value, interval) => {
  return Math.floor(value / interval) * interval;
};

export const discountPriceOnArrearsZero = false;

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const addPrefix = (num) => (num < 10 ? `0${num}` : num);

export const discountPriceItems = [
  {
    id: 10111,
    discount: 10,
  },
  {
    id: 10112,
    discount: 10,
  },
  {
    id: 10113,
    discount: 10,
  },
  {
    id: 10114,
    discount: 10,
  },
  {
    id: 10115,
    discount: 10,
  },
  {
    id: 10116,
    discount: 5,
  },
  {
    id: 10117,
    discount: 5,
  },
  {
    id: 10118,
    discount: 5,
  },
];

export const ConvertOrderArrayToObject = (data) => {
  let total = [];
  let error_orders = [];
  try {
    data.map((order) => {
      order.order.map((item) => {
        if (isNaN(item.quantity) || item.quantity < 1) {
          error_orders.push(item);
        } else {
          let idx = total.findIndex((product) => product.id === item.id);
          if (idx > -1) {
            total[idx] = {
              ...total[idx],
              quantity: total[idx].quantity + parseFloat(item.quantity),
            };
          } else {
            total.push({
              name_urdu: item.name_urdu,
              category_urdu: item.category_urdu,
              id: item.id,
              quantity: item.quantity,
            });
          }
        }
        return true;
      });
      return true;
    });
    return {
      orders_product: total,
      orders_error: error_orders,
      orders_customer: data,
    };
  } catch (error) {
    console.log(error);
  }
};

export const generateBillForCustomer = async (customer) => {
  console.log(customer);

  const arrearAmount =customer.arrearAmount;

  const tray = {};
  const dateInvoiceNo = new Date(customer?.selectedDate);
  const dayNo = dateInvoiceNo.getDate().toString().padStart(2, "0");
  const monthNo = (dateInvoiceNo.getMonth() + 1).toString().padStart(2, "0");
  const yearNo = dateInvoiceNo.getFullYear().toString().slice(-2);
  const formatDate = `${dayNo}-${monthNo}-${yearNo}`;
  const invoiceNo = `${customer?.id}-${formatDate}`;

  const selectedDate = new Date(customer?.selectedDate);
  const day = selectedDate.getDate().toString().padStart(2, "0");

  const month = monthNames[selectedDate.getMonth()];
  const year = selectedDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  return {
    id: customer?.id,
    invoice_no: invoiceNo,
    name_urdu: customer?.name_urdu,
    name_english: customer?.name_english,
    delivery_charges:
      customer?.delivery_charges && customer?.delivery_charges
        ? customer?.delivery_charges
        : 0,
    address_english: customer?.address_english,
    address_urdu: customer?.address_urdu,
    city_english: customer?.city_english,
    city_urdu: customer?.city_urdu,
    date: formattedDate,
    due_date: "2023-03-27",
    preparedBy: customer?.preparedBy,
    ArrearData: customer?.data?.arrears,
    ArrearPayment: customer?.arrearAmount,
    bill:
      customer.view == 1 ? customer.newOrderPayment?.bill : customer.data?.bill,
    pay: customer.data?.amountPaid,
    balance: customer.data?.balance,
    advancePayment: customer.data?.advancePayment,
    items: customer.view == 1 ? customer.newOrder : customer.order,
    returnAmount:
      customer.view === 1
        ? customer.newOrderPayment?.return ?? ""
        : customer.data?.return ?? "",
    payment:
      customer.view === 1
        ? customer.newOrderPayment?.amountPaid ?? ""
        : customer.data?.amountPaid ?? "",
    username: customer.data?.user,
    trayADispatch:tray?.trayADispatch ?? 0,
    trayBDispatch:tray?.trayBDispatch ?? 0,
    trayAReturn:tray?.trayAReturn ?? 0,
    trayBReturn:tray?.trayBReturn ?? 0,
    trayAPending:tray?.trayAPending ?? 0,
    trayBPending:tray?.trayBPending ?? 0,
  };
};


export const generateMonthlyBillForCustomer = async (customer,month) => {

  const invoiceNo = customer?.id ? `${customer?.id}-${month}` : `${month}`;

  return {
    id: customer?.id,
    invoice_no: invoiceNo,
    name_urdu: customer?.name_urdu,
    name_english: customer?.name_english,
    delivery_charges: customer?.data?.deliveryCharge ? customer?.data?.deliveryCharge : 0,
    address_english: customer?.address_english,
    address_urdu: customer?.address_urdu,
    city_english: customer?.city_english,
    city_urdu: customer?.city_urdu,
    date: month,
    due_date: "2023-03-27",
    preparedBy: customer?.preparedBy,
    ArrearData: 0,
    ArrearPayment: 0,
    bill:
      customer.view == 1 ? customer.newOrderPayment?.bill : customer?.data?.bill,
    pay: 0,
    balance: 0,
    advancePayment: 0,
    items: customer.view == 1 ? customer?.newOrder : customer?.order,
    returnAmount:customer?.data?.return,
    payment:0,
    username: customer?.data?.user,
  };
};

export const sortDate = (arrayOfDate) => [...arrayOfDate].sort((a, b) => new Date(b) - new Date(a));
/**
 * Groups price levels by their price
 * Example:
 *
 *  groupByPrice([ [1000, 100], [1000, 200], [993, 20] ]) // [ [ 1000, 300 ], [ 993, 20 ] ]
 *
 * @param levels
 */
export const groupByPrice = (levels) => {
  return levels
    .map((level, idx) => {
      const nextLevel = levels[idx + 1];
      const prevLevel = levels[idx - 1];

      if (nextLevel && level[0] === nextLevel[0]) {
        return [level[0], level[1] + nextLevel[1]];
      } else if (prevLevel && level[0] === prevLevel[0]) {
        return [];
      } else {
        return level;
      }
    })
    .filter((level) => level.length > 0);
};

/**
 * Group price levels by given ticket size. Uses groupByPrice() and roundToNearest()
 * Example:
 *
 * groupByTicketSize([ [1000.5, 100], [1000, 200], [993, 20] ], 1) // [[1000, 300], [993, 20]]
 *
 * @param levels
 * @param ticketSize
 */
export const groupByTicketSize = (levels, ticketSize) => {
  return groupByPrice(
    levels.map((level) => [roundToNearest(level[0], ticketSize), level[1]])
  );
};

export const formatNumber = (arg) => {
  return new Intl.NumberFormat("en-US").format(arg);
};

const BAKE1_CUSTOMER_ID = "0092";

export const isBake1Customer = (customer) => {
  if (!customer) {
    return false;
  }

  const customerId = `${customer.id ?? ""}`.trim();
  return customerId === BAKE1_CUSTOMER_ID;
};

export const resolveUnitPriceForCustomer = (product, customer) => {
  if (!product) {
    return undefined;
  }

  if (isBake1Customer(customer)) {
    const bake1Price = product.bake1Price;

    if (bake1Price !== undefined && bake1Price !== null && bake1Price !== "") {
      return bake1Price;
    }
  }

  return product.price;
};
